export const SearchSuggestions = {
  mounted() {
    const searchInput = this.el.querySelector(".search-input");

    // Track the current active index for autocomplete navigation
    this._autocompleteActiveIndex = -1;

    var autocompleteItems = Array.from(
      this.el.querySelectorAll(".search-suggestion")
    );

    searchInput.addEventListener("keydown", (event) => {
      autocompleteItems = Array.from(
        this.el.querySelectorAll(".search-suggestion") //with async, sometimes the items are not there yet initially
      );
      if (event.key === "ArrowDown" || event.key === "ArrowUp") {
        if (!autocompleteItems.length) return;

        event.preventDefault();

        // Update index
        if (event.key === "ArrowDown") {
          this._autocompleteActiveIndex =
            (this._autocompleteActiveIndex + 1) % autocompleteItems.length;
        } else {
          this._autocompleteActiveIndex =
            (this._autocompleteActiveIndex - 1 + autocompleteItems.length) %
            autocompleteItems.length;
        }

        // Highlight and update value
        autocompleteItems.forEach((item, idx) => {
          item.classList.toggle(
            "opacity-100",
            idx === this._autocompleteActiveIndex
          );
          item.classList.toggle(
            "opacity-70",
            idx !== this._autocompleteActiveIndex
          );
        });
        searchInput.value =
          autocompleteItems[this._autocompleteActiveIndex].textContent.trim();
      }
      if (event.key === "Escape") {
        this._autocompleteActiveIndex = -1;

        const searchSuggestionsAbsolute = this.el.querySelector(
          "#search-suggestions-absolute"
        );
        if (searchSuggestionsAbsolute) {
          this.pushEvent("hide_suggestions", {});
        }
        autocompleteItems.forEach((item) => {
          item.classList.remove("opacity-100");
          item.classList.add("opacity-70");
        });
      }
    });

    // Reset active index when textarea value changes
    searchInput.addEventListener("input", () => {
      if (!autocompleteItems.length) return;

      this._autocompleteActiveIndex = -1;
      autocompleteItems.forEach((item, idx) => {
        item.classList.remove("opacity-100");
        item.classList.add("opacity-70");
      });
    });
  },
};
